import React from 'react';
//import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { red } from '@mui/material/colors';
import { Box, Card, CardContent, Typography, CardHeader } from '@mui/material';
import Icon from '@mui/material/Icon';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';

function CardComponent({ heading, percentageV, value, icon }) {
    const data = [
        { name: 'group A', value: 4 },
        { name: 'group B', value: 3 },
        { name: 'group C', value: 5 },
    ];
    return (
      <Card
        sx={{
          maxWidth: 345,
          backgroundColor: "#FAFAFA",
          borderRadius: 1,
          border: "1px solid #BCC1CA",
          boxShadow: "0px 4px 8px rgba(0, 0, 1, 0.1)",
          padding: "12px",
          fontFamily: "Inter, sans-serif"
        }}
      >
        <CardHeader
          avatar={
            icon === "orders" ? (
              <ShoppingCartIcon sx={{ color: "", fontSize: 25 }} />
            ) : icon === "customers" ? (
              <PeopleIcon sx={{ color: "", fontSize: 25 }} />
            ) : (
              <Icon sx={{ color: red[500] }}>folder</Icon>
            )
          }
          title={
            <Typography variant="h8" sx={{ fontSize: "1.0rem" }}>
              {heading}
            </Typography>
          }
          titleTypographyProps={{ variant: "h8" }} // Ensure title uses h6 styling
        />

        <CardContent>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              {percentageV}% increase
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: "bold" }}
            >
              {value}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
}

export default CardComponent;
